/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description saveSearchModal constants
 */

export const START_CREATING_SAVED_SEARCH =
  '@@nzr/modals/saveSearchModal/START_CREATING_SAVED_SEARCH'
export const DONE_CREATING_SAVED_SEARCH = '@@nzr/modals/saveSearchModal/DONE_CREATING_SAVED_SEARCH'
export const ERROR_CREATING_SAVED_SEARCH =
  '@@nzr/modals/saveSearchModal/ERROR_CREATING_SAVED_SEARCH'
export const RECEIVE_DATA = '@@nzr/modals/saveSearchModal/RECEIVE_DATA'
